import { __rest } from "tslib";
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-ignore-next-line importsNotUsedAsValues
import 'react';
import { motion } from 'framer-motion';
const DataTab = (props) => {
    const { active = false, tabKey, disableTransition = false, className = '', children } = props, remainingProps = __rest(props, ["active", "tabKey", "disableTransition", "className", "children"]);
    if (disableTransition) {
        return _jsx("div", { children: active && children });
    }
    if (!active) {
        return null;
    }
    return (
    // @ts-ignore
    _createElement(motion.div, Object.assign({}, remainingProps, { key: tabKey, initial: { x: 0, y: 0, opacity: 0 }, animate: { x: 0, y: 0, opacity: 1 }, exit: { x: 0, y: 0, opacity: 0 }, transition: { duration: 0.1 }, 
        // TODO: added "fade in" for backwards compatibility for service tests
        // To be removed for next major version
        className: 'fade in' }), children));
};
export default DataTab;
